export const init = () => {
  if (tc_vars.env_template !== 'homepage') return;

  /* ENHANCED E-COMMERCE - CLICK - HOMEPAGE */

  const fwk = CUBE.Analytics;

  const trackerName = AnalyticsConstants.trackers.homepage.homepage.name;
  if (!CUBE.Analytics.trackers.list[trackerName]) return;

  const eventName = 'hpPushProduct';
  if (!CUBE.Analytics.trackers.list[trackerName].events[eventName]) return;

  // Get, and iterates over all events in the tracker
  const event = CUBE.Analytics.trackers.list[trackerName].events[eventName];

  event.postAction($element => {
    localStorage.setItem('Analytics.pendingSearch', '');
    // Get the selected model
    const model = fwk.utils.pagelist.parseProduct(
      $element.closest('article').find('.dkt-product-slider__slide--active')
    );
    fwk.enhanced.setModelVada(model); // set 'model.category' with 'model.vada{}' info (if any)

    // Save the position in the ENHANCED storage
    fwk.enhanced.set({
      id: model.id,
      position: model.position,
      list: model.list,
      variant: model.variant,
      category: model.category,
      label: model.name,
      brand: model.brand,
    });
    fwk.enhanced.sendClick(model);
  });
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-2-click-hp.js